class GetCandidatesByIdsReq{
    constructor(){
        this.candidateIds = [];
    }
}
export default GetCandidatesByIdsReq;